<template>
  <div>
    <serveur-info :erreur="erreur" />
    <div class="container is-fluid">
      <div class="sidebar-page">
        <section class="sidebar-layout">
          <b-sidebar position="absolute" fullheight type="is-light" open right>
            <div>
              <!-- one published action card -->
              <card-action
                :item="action"
                v-for="(action, index) in displayedItems"
                :key="`card-${index}`"
                @hover="itemOnMouseOver"
                @open="(item) => $emit('onOpenItem', item)"
                @on-click-file="(file) => $emit('onClickFile', file)"
              >
              </card-action>

              <hr />
              <b-button
                :disabled="displayedItems.length >= count"
                rounded
                size="is-small"
                @click="loadMore"
                >{{ $t('compTransitionMapsMapItems.load-more') }} ({{
                  displayedItems.length
                }}
                / {{ count }})
              </b-button>
            </div>
          </b-sidebar>
          <div class="block">
            <l-map
              ref="map"
              :bounds="filters.bounds"
              @update:bounds="(bounds) => $emit('onBoundsUpdated', bounds)"
              :style="style"
              :options="leafletMapOptions"
            >
              <l-tile-layer
                :url="jawgUrl"
                attribution="<a href='https://jawg.io?utm_medium=map&utm_source=attribution' title='Tiles Courtesy of Jawg Maps' target='_blank' class='jawg-attrib' >&copy; <b>Jawg</b>Maps</a> | <a href='https://www.openstreetmap.org/copyright' title='OpenStreetMap is open data licensed under ODbL' target='_blank' class='osm-attrib'>&copy; OSM contributors</a>"
              ></l-tile-layer>

              <template>
                <v-marker-cluster @ready="drawLocations" ref="clusterRef">
                </v-marker-cluster>
              </template>
            </l-map>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import L from 'leaflet'
import '@/plugins/leaflet.js'
import { LMap, LTileLayer } from 'vue2-leaflet'

export default {
  name: 'MapItems',
  components: {
    LMap,
    LTileLayer,
    'v-marker-cluster': () => import('vue2-leaflet-markercluster'),
    'serveur-info': () => import('@/components/ServeurInfo.vue'),
    'card-action': () => import('@/components/transition/maps/CardAction.vue')
  },
  emits: ['onOpenItem', 'onClickFile', 'onBoundsUpdated'],
  props: {
    items: {
      type: Array,
      required: false,
      default: () => []
    },
    fullscreen: {
      type: Boolean,
      required: false,
      default: () => false
    },
    count: {
      type: Number,
      required: false,
      default: () => 0
    },
    localPageSize: {
      type: Number,
      required: false,
      default: () => 20
    }
  },
  data: function () {
    return {
      erreur: '',
      leafletMapOptions: {
        scrollWheelZoom: true
      },
      filters: {
        bounds: [
          [-66.79190947341796, -94.21875],
          [76.01609366420996, 187.73437500000003]
        ],
        sort: 'sort:update:desc'
      },
      localPage: 1,
      jawgUrl: `https://tile.jawg.io/${process.env.VUE_APP_JAWG_MAP_STYLE}/{z}/{x}/{y}.png?access-token=${process.env.VUE_APP_JAWG_MAP_ACCESS_TOKEN}`
    }
  },
  computed: {
    displayedItems () {
      return this.items.slice(0, this.localPage * this.localPageSize)
    },
    style: function () {
      let height = 600
      if (this.fullscreen) {
        height = 800
      }
      let style = `z-index: 0; height: ${height}px; width: 100%`
      return style
    }
  },
  watch: {
    items: function (newItems, oldItems) {
      this.drawLocations()
      if (newItems.length <= oldItems.length) {
        // rationale: reinitialize localPage when a new filter is applied
        // ie which happens when the number of items change in a decreasing way
        this.localPage = 1
      }
    }
  },
  methods: {
    loadMore () {
      if (this.displayedItems.length >= this.items.length) {
        // ask for more
        this.$emit('onLoadMore')
        this.localPage = this.localPage + 1
      } else {
        // just increase the number of displayedItems
        this.localPage = this.localPage + 1
      }
    },
    generatePopup (item) {
      let content =
        '<a href="/transition-1point5/public/actions/' +
        item.id +
        '" target="_blank">' +
        '<section><span class="icon"><i class="fa fa-home"></i></span>' +
        item.entity.name +
        '</section>' +
        '<section><span class="icon"><i class="fa fa-lightbulb-o"></i></span>' +
        item.title +
        '</section>' +
        '</a>'
      return content
    },
    /**
     * Draw all the passed items
     */
    drawLocations () {
      if (this.$refs.map === undefined || this.$refs.clusterRef === undefined) {
        return
      }

      let map = this.$refs.map.mapObject
      let markers = this.$refs.clusterRef.mapObject
      markers.clearLayers()
      for (let item of this.items) {
        let marker = L.marker([
          item.entity.latitude,
          item.entity.longitude
        ]).bindPopup(this.generatePopup(item))
        markers.addLayer(marker)
      }
      map.addLayer(markers)
    },
    itemOnMouseOver (item) {
      this.currentItem = item
    }
  }
}
</script>

<style>
.b-sidebar .sidebar-content {
  background-color: rgb(255, 255, 255, 0.8) !important;
  z-index: 29 !important;
  width: 400px !important;
}

@import '~leaflet/dist/leaflet.css';
@import '~leaflet.markercluster/dist/MarkerCluster.css';
@import '~leaflet.markercluster/dist/MarkerCluster.Default.css';
</style>
